var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 35",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.84277,
    width: 35.157,
    height: 35,
    rx: 8,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.343 10h-6.75c-0.6225 0-1.155 0.375-1.38 0.915l-2.265 5.2875c-0.0675 0.1725-0.105 0.3525-0.105 0.5475v1.5c0 0.825 0.675 1.5 1.5 1.5h4.7325l-0.7125 3.4275-0.0225 0.24c0 0.3075 0.1275 0.5925 0.33 0.795 0.4396 0.4354 1.1485 0.4335 1.5856-0.0044l4.1444-4.1506c0.2775-0.27 0.4425-0.645 0.4425-1.0575v-7.5c0-0.825-0.675-1.5-1.5-1.5zm0 8.5858c0 0.2652-0.1054 0.5196-0.2929 0.7071l-2.9621 2.9621 0.7074-3.4032c0.0645-0.3105-0.1725-0.6018-0.4895-0.6018h-5.4629c-0.2762 0-0.5-0.2239-0.5-0.5v-0.5895c0-0.2708 0.055-0.5389 0.1617-0.7878l1.9584-4.5697c0.0788-0.1838 0.2596-0.303 0.4596-0.303h6.0203c0.2209 0 0.4 0.1791 0.4 0.4v6.6858zm3-7.7571c0-0.4577 0.371-0.8287 0.8286-0.8287 0.4577 0 0.8287 0.371 0.8287 0.8287v7.6426c0 0.4577-0.371 0.8287-0.8287 0.8287-0.4576 0-0.8286-0.371-0.8286-0.8287v-7.6426z",
    fill: "#485259"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/ThumbsDown.e639872bac330e3e7ea117cf7fb71eab.svg";
export { ForwardRef as ReactComponent };